import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { InternalRoute, ExternalLink, HeaderUser } from '@uiowa/uiowa-header';
import { ApplicationUser, UserService, ImpersonationService } from './core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  applicationName = 'MerchantAccount';
  externalLinks = [
    new ExternalLink('Employee Self Service', 'https://hris.uiowa.edu/portal18')
  ];
  internalRoutes: InternalRoute[];
  user: HeaderUser;

  startTimer: boolean;
    private userSubscription: Subscription;

    loading = true;

  constructor(
      private readonly userService: UserService,
      private router: Router,
  ) {}

    ngOnInit(): void {
        this.router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
    this.userSubscription = this.userService.user$.subscribe(user => {
      this.user = <HeaderUser>{
        userName: user.hawkId
      };
      this.setupNavMenus(user);
      this.startTimer = user.isAuthenticated();
    });
  }

  setupNavMenus(user: ApplicationUser) {
    this.internalRoutes = [];
      this.internalRoutes.push(new InternalRoute('My Merchant Accounts', 'account/mine'));
    if (user.isAdmin()) {
        this.internalRoutes = [
            ...this.internalRoutes,
            new InternalRoute('Admin', '',
            [
                new InternalRoute('Merchant Accounts', 'account/standard'),
                new InternalRoute('Cashnet Storefront', 'account/cashnet'),
                new InternalRoute('Merchant Profiles', 'merchant-profiles'),
                new InternalRoute('Invalid Merchant Accounts', 'account/invalid')
            ])
        ];
    }
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  navigationInterceptor(event: RouterEvent): void {
      if (event instanceof NavigationStart) {
          this.loading = true;
      }
      if (event instanceof NavigationEnd) {
          this.loading = false;
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
          this.loading = false;
      }
      if (event instanceof NavigationError) {
          this.loading = false;
      }
  }
}
